import { Button } from "@mui/material"
import { useState } from "react"
import AddAsset from "../modals/AddAsset"
import { getAllAssets, getAssetFilters, getAssetSort } from "../../api"
import ListData from "../common/ListData"
import AddRoundedIcon from "@mui/icons-material/AddRounded"
import AssetCard from "../cards/AssetCard"

const Assets = ({ data }) => {
  const [addAssetModal, setAddAssetModal] = useState(false)

  const CTA = () => (
    <Button
      onClick={() => setAddAssetModal(true)}
      variant="contained"
      startIcon={<AddRoundedIcon />}
    >
      Add Asset
    </Button>
  )

  return (
    <>
      <ListData
        getFilters={getAssetFilters}
        getSort={getAssetSort}
        getAllData={getAllAssets}
        initialFilters={{}}
        HeaderRight={CTA}
        Card={AssetCard}
      />
      <AddAsset
        isOpen={addAssetModal}
        close={() => setAddAssetModal(false)}
        data={data}
      />
    </>
  )
}

export default Assets
